<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-title>Kentix Datenstand aktualisieren</v-card-title>
          <v-card-subtitle>
            ELOCOM aktualisiert alle vier Stunden automatisch die Daten.
            Diese Funktion aktualisiert sofort alle geladenen Daten und lädt sie erneut vom Backend. Eine mehrfache Ausführung in kurzer Zeit ist zu vermeiden, da dies zu unnötiger Belastung auf dem SiteManager führen kann. Der Aktualisierungsvorgang kann einige Sekunden dauern.
            <br><br>
            Diese Funktion ist nur sinnvoll, wenn neue Schlösser, Benutzer oder Schließgruppen sofort in ELOCOM zur Verfügung stehen sollen.
          </v-card-subtitle>
          <v-card-actions>
            <v-btn
              class="primary"
              :loading="isUpdating || !this.$store.state.kentix.users"
              :disabled="isUpdating || !this.$store.state.kentix.users"
              @click="update"
            >
              Datenstand aktualisieren
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-title>Schließgruppen</v-card-title>
          <v-card-text>
            <v-tooltip
              v-for="(levelprofile, index) in $store.state.kentix.levelprofiles"
              :key="index"
              left
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  v-on="on"
                  class="mr-1 mb-1"
                  small
                >
                  {{ levelprofile.name }}
                </v-chip>
              </template>
              <div
                v-if="levelprofile.doorlocks.length == 0"
              >
                Diese Schließgruppe enthält keine Türen
              </div>
              <div
                v-else
              >
                Diese Schließgruppe enthält folgende Türen:
              </div>
              <div
                v-for="(doorlock, index) in levelprofile.doorlocks"
                :key="index"
              >
                - {{ $store.getters.get_kentix_device(doorlock).name }}
              </div>
            </v-tooltip>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "ls-settings",
  data() {
    return {
      isUpdating: false
    };
  },
  methods: {
    update(){
      if (this.isUpdating) return; // extra safety
      this.isUpdating = true;
      this.$store.state.kentix.alarmgroups_status = {}
      this.$store.state.kentix.users = null
      this.$store.state.kentix.devices = null
      this.$store.state.kentix.devices_lut = {}
      this.$store.state.kentix.levelprofiles = null
      this.$store.state.kentix.levelprofiles_lut = {}
      this.$store.state.kentix.access_log = null
      this.$store.dispatch("update", { "context": "/kentix/update" })
      this.isUpdating = false;
    }
  }
};
</script>



<style scoped>

</style>